/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { object, Schema, string } from '../schema';

export interface DebtorAccount {
  schemeName: string;
  identification: string;
  name: string;
}

export const debtorAccountSchema: Schema<DebtorAccount> = object({
  schemeName: ['SchemeName', string()],
  identification: ['Identification', string()],
  name: ['Name', string()],
});
